import { Pause } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionHold(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <Pause size={16} className='action_btn text-warning me-3'
                    onClick={onClick}
                    data-tooltip-id='hold'
                    data-tooltip-content={text}
                    data-tooltip-place="top"
                />
            }

            <Tooltip id='hold' className='bg-warning tooltip_msg' />
        </>
    )
}